/* eslint-disable no-shadow */
import createReducer from '../../helpers/createReducer';
import {
  header as state
} from '../store';

export default createReducer(state, {
  SET_HEADER_STATE: (state, { data: headerState }) => ({ ...state, headerState }),
});
